import ko from '../locales/ko-KR';
import en from '../locales/en-US';


const messages = {
  'en-US': en,
  'ko-KR': ko
};

export function getI18n() {
  const lang = 'ko-KR'; // default language
  return messages[lang] || messages['ko-KR'];
}


// WEBPACK FOOTER //
// ./src/utils/i18nLoader.js